import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "loading"]
  static values = { text: String }

  connect() {
    this.originalText = this.submitTarget.textContent
    this.originalHTML = this.submitTarget.innerHTML
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  submit() {
    this.submitTarget.disabled = true
    this.submitTarget.classList.add("opacity-75", "cursor-wait")
    this.submitTarget.setAttribute("aria-busy", "true")

    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = "flex"
      this.loadingTarget.setAttribute("aria-live", "polite")
    }

    const loadingText = this.textValue || "Loading..."
    this.submitTarget.innerHTML = `
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span>${loadingText}</span>
    `
  }

  handleSubmitEnd(event) {
    this.reset()
  }

  reset() {
    this.submitTarget.disabled = false
    this.submitTarget.classList.remove("opacity-75", "cursor-wait")
    this.submitTarget.removeAttribute("aria-busy")
    this.submitTarget.innerHTML = this.originalHTML

    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = "none"
    }
  }
}
